export enum UserRoleEnum {
  SUPERADMIN = 'superadmin',
  LEADER = 'leader',
  RECRUITER = 'recruiter',
  CANDIDATE = 'candidate_user',
  CLIENT_COMPANY_USER = 'client_company_user'
}
